import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = {
    copiedText: { type: String, default: "" }
  }

  connect() {
    if (this.hasButtonTarget) {
      this.tooltip = Tooltip.getOrCreateInstance(this.buttonTarget, {
        title: this.copiedTextValue,
        trigger: "manual",
        placement: "top"
      })
    }
  }

  async copy(event) {
    const button = event.currentTarget
    const source = this.hasSourceTarget ? this.sourceTarget : null
    if (!source) {
      return
    }

    const value = source.value || source.textContent || ""
    if (value.length === 0) {
      return
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value)
      } else if (source.select) {
        source.focus()
        source.select()
        document.execCommand("copy")
      }
      if (this.tooltip) {
        this.tooltip.show()
        clearTimeout(this.tooltipTimeout)
        this.tooltipTimeout = setTimeout(() => this.tooltip.hide(), 1500)
      }
    } catch (error) {
      console.warn("Clipboard copy failed", error)
    } finally {
      button.blur()
    }
  }
}
